// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import * as sdk from '@canton-network/dapp-sdk';
import { useSnackbar } from 'notistack';
import React from 'react';
import { Circle } from '@mui/icons-material';
import { Chip } from '@mui/material';

export const DappGatewayButton: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [isConnected, setIsConnected] = React.useState(false);

  React.useEffect(() => {
    sdk
      .status()
      .then((r) => {
        if (r.connection.isConnected) {
          setIsConnected(true);
        } else {
          setIsConnected(false);
        }
      })
      .catch(() => {
        setIsConnected(false);
      });
  }, [isConnected]);
  return (
    <Chip
      onClick={() => {
        sdk.open().catch((e) => {
          enqueueSnackbar(`${e}`, { variant: 'error' });
        });
      }}
      icon={
        <Circle
          color={isConnected ? 'success' : 'error'}
          sx={{ height: '10px', width: '10px' }}
          fontSize="small"
        />
      }
      label="Wallet"
      size="small"
    />
  );
};
